// Veri Girişi Değerleri: yedi listenin Firestore yolu, varsayılanları ve kayıt
// biçimi (eski sayfadakiyle aynı). Metinler: dataEntryValues.lists.<key>.
//
//  - mode 'indexed' (departmanlar, roller, gelir listeleri): belge kimliği sıra
//    numarası, değer kırpılır, boşlar kaydedilmez; silmeden önce kullanım
//    kontrol edilir (kullanılıyorsa pasife alma önerilir) ve silme hemen kaydedilir.
//  - mode 'auto' (gider listeleri): otomatik belge kimliği, id = sıra + 1,
//    değer olduğu gibi; silme yerel, "Kaydet" ile yazılır.

export const VALUE_LISTS = [
  {
    key: 'departments',
    group: 'people',
    path: ['DataEntryValues', 'departments', 'EmployeeDepartments'],
    mode: 'indexed',
    lockable: true,
    reference: { collection: 'Employees', field: 'department' },
    defaults: [{ value: '', isActive: true }],
  },
  {
    key: 'roles',
    group: 'people',
    path: ['DataEntryValues', 'roles', 'AuthorizationRoles'],
    mode: 'indexed',
    lockable: true,
    reference: { collection: 'Users', field: 'role' },
    defaults: [
      { value: 'Finans Yöneticisi', isActive: true },
      { value: 'Proje Yöneticisi', isActive: true },
      { value: 'Saha Koordinatörü', isActive: true },
      { value: 'İnsan Kaynakları', isActive: true },
      { value: 'SMO Lead', isActive: true },
    ],
  },
  {
    key: 'incomeSources',
    group: 'income',
    path: ['DataEntryValues', 'income', 'IncomeSources'],
    mode: 'indexed',
    lockable: true,
    reference: { collection: 'Budgets', field: 'BütçeKaynak' },
    defaults: [
      { value: 'Satışlar', isActive: true },
      { value: 'Hizmetler', isActive: true },
      { value: 'Yatırımlar', isActive: true },
      { value: 'Diğer', isActive: true },
    ],
  },
  {
    key: 'incomeCategories',
    group: 'income',
    path: ['DataEntryValues', 'income', 'IncomeCategories'],
    mode: 'indexed',
    lockable: true,
    reference: { collection: 'Budgets', field: 'BütçeKategorisi' },
    defaults: [
      { value: 'Ana Gelir', isActive: true },
      { value: 'Yan Gelir', isActive: true },
      { value: 'Faiz Geliri', isActive: true },
    ],
  },
  {
    key: 'expenseSources',
    group: 'expense',
    path: ['DataEntryValues', 'expense', 'ExpenseSources'],
    mode: 'auto',
    lockable: false,
    defaults: [
      { value: 'Satıcı', isActive: true },
      { value: 'Hizmet', isActive: true },
      { value: 'Diğer', isActive: true },
    ],
  },
  {
    key: 'expenseTypes',
    group: 'expense',
    path: ['DataEntryValues', 'expense', 'ExpenseTypes'],
    mode: 'auto',
    lockable: false,
    defaults: [
      { value: 'Gider', isActive: true },
      { value: 'Yatırım', isActive: true },
    ],
  },
  {
    key: 'expenseCategories',
    group: 'expense',
    path: ['DataEntryValues', 'expense', 'ExpenseCategories'],
    mode: 'auto',
    lockable: false,
    defaults: [
      { value: 'Sabit Gider', isActive: true },
      { value: 'Değişken Gider', isActive: true },
      { value: 'Yatırım Gideri', isActive: true },
    ],
  },
];

export const GROUPS = ['people', 'income', 'expense'];
